(function(){
  /* Anchor on the timeline's own slider so this works whether the timeline and
     uses grid share one .lvl-hist block or live in two separate blocks. */
  var anchor=document.getElementById('lvl-slider');
  if(!anchor) return;
  var root=anchor.closest('.lvl-hist')||anchor.parentElement;
  if(root.dataset.lvlHistInit==='1') return;
  root.dataset.lvlHistInit='1';
  root.classList.add('lvl-hint');
  function stopHint(){root.classList.remove('lvl-hint');if(hintTimer){clearTimeout(hintTimer);hintTimer=null;}}
  var hintTimer=setTimeout(stopHint,6000);

  /* Image URLs are milestone-indexed (0..6), NOT file-numbered. The colonial
     milestone (index 3) uses hemphistory5.png; see comments on each line.
     URLs assume the 7 files are uploaded to Shopify Files under these exact
     names (store Files CDN prefix confirmed from live site). ?width=1400 lets
     the CDN serve a resized/optimized copy of the multi-MB originals. */
  var CDN="https://cdn.shopify.com/s/files/1/0900/9990/8889/files/";
  var W="?width=1400";
  var IMAGES=[
    CDN+"hemphistory1.png"+W,  /* 0: ~8000 BCE  ancient East Asia (Shennong)        */
    CDN+"hemphistory2.png"+W,  /* 1: Antiquity  India & Middle East trade routes    */
    CDN+"hemphistory3.png"+W,  /* 2: Middle Ages Europe rope/sail/paper (ropewalk)  */
    CDN+"hemphistory5.png"+W,  /* 3: 1600s-1700s colonial America (Cutting Hemp KY) */
    CDN+"hemphistory4.png"+W,  /* 4: 1839       Cannabis Indica fluidextract         */
    CDN+"hemphistory6.png"+W,  /* 5: 20th c.    prohibition (1937 tax stamps)        */
    CDN+"hemphistory7.png"+W   /* 6: 2018       modern hemp field                    */
  ];

  var M=[
    {year:"~8000 BCE",title:"First cultivation in East Asia",alt:"Ancient hemp cultivation in early China",art:"Ancient East Asia: early hemp cultivation for fiber and food, with cannabis among early medical texts.",body:"Hemp is among the earliest crops humans deliberately cultivated — one of the oldest plants we have ever grown. In ancient China it was valued for both fiber and food, and Chinese medical texts dating back thousands of years reference cannabis preparations among the remedies of the era. Food, fiber, medicine: few plants have done so many jobs, for so long."},
    {year:"Antiquity",title:"Spread through India & the Middle East",alt:"Trade routes carrying hemp through India and the Middle East",art:"India & the Middle East: cannabis in medicine and ritual, hemp moving along spice and textile trade routes.",body:"The plant and its uses travel westward. In India, cannabis preparations become woven into both medicine and ritual life. Across the Middle East, hemp fiber and seed move along the same trade routes as spices and textiles."},
    {year:"Middle Ages onward",title:"Rope, sail & paper in Europe",alt:"Hemp rope and sailcloth on a European sailing ship",art:"Europe: hemp rope, sailcloth, and paper. Ships rigged with hemp; the industrial era of the plant.",body:"In Europe, hemp's industrial value comes to the front. Strong, durable fiber makes it the backbone of rope and sailcloth for centuries. The age of seafaring runs, quite literally, on hemp rigging. Paper is made from it too."},
    {year:"1600s–1700s",title:"A mandated colonial crop",alt:"A hemp field in the early American colonies",art:"Colonial America: hemp as a common, sometimes legally required crop. Everyday agricultural infrastructure.",body:"Hemp crosses the Atlantic with European settlers and becomes a common, and in some places legally required, crop in the early American colonies. For most of this history it is simply infrastructure."},
    {year:"1839",title:"Entry into Western medicine",alt:"A 19th-century apothecary with cannabis tinctures",art:"19th-century medicine: O'Shaughnessy's research, cannabis tinctures on the pharmacy shelf.",body:"Irish physician William O'Shaughnessy, working in India, presents his research on cannabis preparations to the Medical and Physical Society of Calcutta. Through the rest of the 19th century, cannabis tinctures become a familiar part of the pharmacy shelf."},
    {year:"20th century",title:"Prohibition & what was lost",alt:"Hemp swept into 20th-century prohibition",art:"20th century: prohibition. Hemp restricted alongside marijuana; the crop and its research go quiet.",body:"A wave of prohibition sweeps hemp and cannabis together into legal restriction, with little distinction between intoxicating and non-intoxicating varieties. An industrial crop with thousands of years of use behind it largely disappears from Western agriculture and medicine for decades."},
    {year:"2018",title:"The modern resurgence",alt:"A modern hemp field under open sky",art:"Modern resurgence: the 2018 Farm Bill. Hemp returns to cultivation, research, and wellness.",body:"The U.S. Farm Bill federally legalizes hemp, defined as cannabis with no more than 0.3% delta-9 THC by dry weight. Cultivation, research, and commerce resume. What follows is less an invention than a recovery: the old medicinal lineage, studied now with modern tools."}
  ];

  var slider=root.querySelector('#lvl-slider'),
      notches=root.querySelector('#lvl-notches'),
      fill=root.querySelector('#lvl-fill'),
      yEl=root.querySelector('#lvl-year'),
      tEl=root.querySelector('#lvl-etitle'),
      bEl=root.querySelector('#lvl-body'),
      img=root.querySelector('#lvl-img'),
      stage=root.querySelector('#lvl-stage'),
      phS=root.querySelector('#lvl-ph-s'),
      prev=root.querySelector('#lvl-prev'),
      next=root.querySelector('#lvl-next');

  M.forEach(function(m,i){
    var b=document.createElement('button');
    b.className='lvl-notch';b.type='button';
    b.setAttribute('aria-label',m.year+': '+m.title);
    b.addEventListener('click',function(){stopHint();slider.value=i;render();});
    notches.appendChild(b);
  });

  function render(){
    var i=parseInt(slider.value,10),m=M[i];
    yEl.textContent=m.year;tEl.textContent=m.title;bEl.textContent=m.body;
    phS.textContent=m.art;
    var src=IMAGES[i]||"";
    if(src){
      stage.classList.add('has-img');
      img.classList.remove('is-shown');
      img.onload=function(){img.classList.add('is-shown');};
      img.onerror=function(){stage.classList.remove('has-img');img.classList.remove('is-shown');};
      img.src=src;img.alt=m.alt;
    }else{
      stage.classList.remove('has-img');
      img.classList.remove('is-shown');
      img.removeAttribute('src');img.alt="";
    }
    fill.style.width=(i/(M.length-1)*100)+'%';
    var kids=notches.children;
    for(var j=0;j<kids.length;j++){
      kids[j].classList.remove('is-active','is-passed');
      if(j<i)kids[j].classList.add('is-passed');
      if(j===i)kids[j].classList.add('is-active');
    }
    prev.disabled=(i===0);next.disabled=(i===M.length-1);
  }
  slider.addEventListener('input',function(){stopHint();render();});
  prev.addEventListener('click',function(){stopHint();if(+slider.value>0){slider.value=+slider.value-1;render();}});
  next.addEventListener('click',function(){stopHint();if(+slider.value<M.length-1){slider.value=+slider.value+1;render();}});
  render();
})();
